/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API21148Item {
  
  /** 模块id */
  moduleId?: string;
  
  /** 模块名称 */
  moduleName?: string;
  
  /** 模块标识 */
  moduleNameEn?: string;
  
  /** 模块图标icon */
  moduleIcon?: string;
  
  /** 模块描述 */
  moduleRemark?: string;
  
  /** 菜单相对路径 */
  menuPath?: string;
  
  /** 搜索内容 */
  searchContent?: string;
  
};
    
  



  export type API21148Req = {};



export interface API21148Res {
  /** T  */
  list?: API21148Item[];
  
};


// 21148 获取用户锁住的模块

export interface IUseGetAPI21148Return {
  /** 获取用户锁住的模块: 接口请求状态 */
  isAPI21148Loading: boolean;
  /** 获取用户锁住的模块: 接口请求返回数据 */
  dataAPI21148: API21148Res;
  /**  获取用户锁住的模块: 接口数据请求方法 */
  fetchAPI21148Data:  ( config?: YWRequestConfig) => Promise<API21148Res>;
  /** 获取用户锁住的模块: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI21148 = ():IUseGetAPI21148Return => {
  let isMount = true;
  const [isAPI21148Loading, setIsAPI21148Loading] = useState(false);
  const [dataAPI21148, setDataAPI21148] = useState<API21148Res>({} as API21148Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/cloud/user/lock/modules`;

  const fetchAPI21148Data = async ( config?: YWRequestConfig): Promise<API21148Res> => {
  
    if ( isMount ) {
      setIsAPI21148Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API21148Res>(`${basePath}/ywwl-admin/desktop/cloud/user/lock/modules`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI21148(res || {} as API21148Res);
        setIsAPI21148Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI21148Loading(false);
      }
      return false as unknown as API21148Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI21148Loading,
    dataAPI21148,
    fetchAPI21148Data,
    requestUrl,
  }
}

